import { apiRequest } from './core/client';
import { SyncStatusSchema, parseWithSchema, type SyncStatus } from './schemas';

export type { SyncStatus };

// Re-export nested types for convenience
export type { AccountSyncStatus, SyncMailboxStatus, SyncJob } from './schemas';

// ============================================================================
// Sync Status
// ============================================================================

export async function fetchSyncStatus(accountId?: string): Promise<SyncStatus> {
  const data = await apiRequest<unknown>({
    path: accountId
      ? `/accounts/${encodeURIComponent(accountId)}/sync/status`
      : '/sync/status',
  });
  return parseWithSchema(SyncStatusSchema, data, 'fetchSyncStatus');
}

export async function triggerAccountSync(accountId: string): Promise<void> {
  await apiRequest<void>({
    path: `/accounts/${encodeURIComponent(accountId)}/sync`,
    method: 'POST',
  });
}

export async function triggerAccountFastRecovery(accountId: string): Promise<void> {
  await apiRequest<void>({
    path: `/accounts/${encodeURIComponent(accountId)}/sync/recover-gap`,
    method: 'POST',
  });
}

export async function refreshMailboxList(accountId: string): Promise<void> {
  await apiRequest<void>({
    path: `/accounts/${encodeURIComponent(accountId)}/sync/refresh-mailboxes`,
    method: 'POST',
  });
}
